Property_detail = {
	p_initialised : false
	,
	init : function()
	{	
		// Run list setup procedures.
		Property_detail.setup();
		
		// Track whether list has been initilised.
		Property_detail.p_initialised = true;
	}
	,
	setup : function()
	{	
		// Collapsing introduction text.
		jQuery('.oc--introduction-wrapper').each(function(){
			
			// Define more linnk.
			var more_link = '<a href="javascript:;" class="oc--read-more">read more</a>';
			
			// Place more link.
			jQuery(this).find('.oc--introduction').after(more_link);
			
			// More link should open full description.
			jQuery(this).find('.oc--read-more').click(function(){
				
				if( jQuery(this).parent().hasClass('open') )
				{
					jQuery(this).parent().find('.oc--description').slideUp('fast',function(){
						jQuery(this).parent().removeClass('open');
					});
					
					jQuery(this).text('read more');
				}
				else
				{
					jQuery(this).parent().find('.oc--description').slideDown('fast',function(){
						jQuery(this).parent().addClass('open');
					});
					
					jQuery(this).text('read less');
				}
				
			});
			
		});
		
		jQuery('body.property #oc-quick-access-menu .booking').click(function(pm_event){
			pm_event.preventDefault();
			
			//var offset = jQuery('#header').height();
			
			jQuery([document.documentElement, document.body]).animate({
		        scrollTop: jQuery('#booking').offset().top - 100
		    }, 500);
		});
		
		// Collapsible Terms on specials panels.
		jQuery('#specials-panel .disclaimer .oc-toggle, #discount-alert .disclaimer .oc-toggle').click(function(event){
			//jQuery(this).closest('.disclaimer').toggleClass('open');
			
			if( jQuery(this).closest('.disclaimer').hasClass('open') )
			{
				jQuery(this).closest('.disclaimer').find('.terms').slideUp('fast',function(){
					jQuery(this).closest('.disclaimer').removeClass('open');
				});
			}
			else
			{
				jQuery(this).closest('.disclaimer').find('.terms').slideDown('fast',function(){
					jQuery(this).closest('.disclaimer').addClass('open');
				});
			}
			
			event.preventDefault();
		});
	}
};

jQuery(document).ready(function(jQuery){
	
	/*
		sh__site_object = global object loaded via WordPress.
	*/
	
	// Initilaise property list.
	Property_detail.init();
	
});
